import axios from "axios";
import Config from "../../config";

const actionSolicitarDiagnostico = (chatId, data) =>
    axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/diagnosticos/solicitar`,
        data,
    });

export default actionSolicitarDiagnostico;
